import React from "react";
import "./components/App.scss";

function App() {
  return (
    <div id="cf-wrapper">
      <div id="cf-error-details" className="cf-error-details-wrapper">
        <div className="cf-wrapper cf-header cf-error-overview">
          <h1>Acesso Restrito</h1>
        </div>
        <div className="cf-section cf-highlight">
          <div className="cf-wrapper">
            <div className="cf-screenshot-container cf-screenshot-full">
              <header className="lock"></header>
            </div>
          </div>
        </div>
        <div className="cf-section cf-wrapper">
          <div className="cf-columns two">
            <div className="cf-column">
              <h2>Por que fui avisado(a)?</h2>
              <p>
                É proibido abrir o <strong>Dev Tools</strong> para fazer uma
                cópia, pois este site tem todos os direitos reservados.
              </p>
            </div>
            <div className="cf-column">
              <h2>
                Quero criar um site. O que posso fazer para aprender a
                programar?
              </h2>
              <p>
                Você pode entrar em contato com o desenvolvedor&nbsp;
                <a href="https://t.me/tifodao" rel="noopener noreferrer">
                  Diego Melo
                </a>
                &nbsp;para informar se realmente quer aprender a programar. E,
                para isso, o site está em segurança e protegido.
              </p>
            </div>
          </div>
        </div>
        <div className="cf-error-footer cf-wrapper w-240 lg:w-full py-10 sm:py-4 sm:px-8 mx-auto text-center sm:text-left border-solid border-0 border-t border-gray-300">
          <p className="text-13">
            <span className="cf-footer-item sm:block sm:mb-1">
              <span>Tecnologia da informação por&nbsp;</span>
              <a
                rel="noopener noreferrer"
                href="https://t.me/tifodao"
                id="brand_link"
              >
                iDweb - Soluções
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
